import { Injectable } from '@angular/core';
import { Base64ToBlobService } from './base64-to-blob.service';
import { DomSanitizer, SafeResourceUrl, SafeUrl } from '@angular/platform-browser';
import { PrintWebSocketService } from './print-web-socket.service';
import printJS from 'print-js';

@Injectable()
export class PdfService {

  contentType = 'application/pdf';

  constructor(
    private base64ToBlobService: Base64ToBlobService,
    private printWebSocketService: PrintWebSocketService,
    private domSanitizer: DomSanitizer) {
      printWebSocketService.initConnection();
    }


  directPrintEnabled(): boolean {
    return !this.printWebSocketService.isClosed;
  }

  base64ToPdfUrl(base64: string): string {
    const blob = this.base64ToBlobService.base64toBlob(base64, this.contentType);
    return window.URL.createObjectURL(blob);
  }

  base64ToPdfSafeResourceUrl(base64: string): SafeResourceUrl {
    const blobUrl = this.base64ToPdfUrl(base64);
    return this.domSanitizer.bypassSecurityTrustResourceUrl(blobUrl);
  }

  base64ToPdfSafeUrl(base64: string): SafeUrl {
    const blobUrl = this.base64ToPdfUrl(base64);
    return this.domSanitizer.bypassSecurityTrustUrl(blobUrl);
  }

  directPrint(
    printType: string, jsonData: string ): void {
      this.printWebSocketService.sendDirectPrint(printType, jsonData);
  }

  base64ToPdfPrint(
    base64: string,
    printType: string = '',
    disablePrintServer: boolean = false): void {

    if ( !this.printWebSocketService.isClosed && !disablePrintServer ) {
      this.printWebSocketService.sendPrint(printType, base64);
    } else {
      const pdfbUrl = this.base64ToPdfUrl(base64);
      this.pdfUrlToPdfPrint(pdfbUrl);
    }
  }

  pdfUrlToPdfSafeResourceUrl(pdfUrl: string): SafeResourceUrl {
    return this.domSanitizer.bypassSecurityTrustResourceUrl(pdfUrl);
  }

  pdfUrlToPdfPrint(pdfUrl: string)  {
    printJS({printable: pdfUrl, type:'pdf', showModal:false})
  }
}
